import { PapiRequestDaSharedUserCalculateEarnings } from '@wix/da-papi-types';
import { reduxKey } from './constants';

export enum RequestStatus {
  Idle = 'idle',
  Fetching = 'fetching',
  Error = 'error',
}

export interface RequestInfo {
  status: RequestStatus;
  errorMessage?: string;
}

export interface DisplayData {
  productType: PapiRequestDaSharedUserCalculateEarnings['product_type'];
  isResale: boolean;
  actualPrice: number;
  serviceFee: number;
  serviceFeePercentage: number;
  earnings: number;
  requestInfo: RequestInfo;
}

export interface EarningsCalculatorStoreSlice {
  isReduxLoaded: boolean;
  displays: {
    [key: string]: DisplayData;
  };
}

export interface EarningsCalculatorStoreState {
  [reduxKey]: EarningsCalculatorStoreSlice;
}
